<template>
    <div v-if="isreadshow">
        <!-- <div v-if="isTsNm" style="color:red;font-weight:bold;">注:应唐山市住建监督部门要求，代理必须选择发布补遗书或澄清的形式，回复投标人质疑问题，请勿直接回复。</div> -->
        <my-table :data="tableData" :max-height="tableHeight">
            <el-table-column label="问题标题" prop="yqcqwttitle" min-width="220" fixed></el-table-column>
            <el-table-column label="问题内容" prop="yqcqwt" min-width="220">
                <template slot-scope="scope">
                    <div v-html="scope.row.yqcqwt"></div>
                </template>
            </el-table-column>
            <el-table-column label="相关内容" prop="by5" min-width="150">
                <template slot-scope="scope">
                    <div v-if="scope.row.by4 === '1'">
                        <p><span style="font-weight: 600;">质疑单位：</span><span style="color: blue">{{scope.row.adddwname}}</span></p>
                    </div>
                    <div v-if="scope.row.by5 !== '0'">
                        <p><span style="font-weight: 600;">附件：</span>包含附件数：<span style="color: blue">{{scope.row.by5}}</span>&nbsp;&nbsp;个，请前往回复页或详情页进行下载查看</p>
                    </div>
                    <div v-if="scope.row.by5 === '0'">
                        <p><span style="font-weight: 600;">附件：</span>无附件</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="标段名称" prop="bdname"></el-table-column>
            <el-table-column label="提交时间" sortable prop="yqtjtime"></el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                     <div v-if="scope.row.by1==='1' && !reply"></div>
                     <div v-else>
                        <my-tag type="danger" v-if="scope.row.exthfbj===null||scope.row.exthfbj==='0'">未回复</my-tag>
                        <my-tag type="success" v-else>已回复</my-tag>
                     </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <div v-if="scope.row.by1 === '1' && !reply">
                        <my-btn type="detail" @click="detail(scope.row.wtcode)">详情</my-btn>
                        <my-tag type="warning" >此问题为投标人匿名提出,回复请发布补遗或者澄清</my-tag>
                    </div>
                    <div v-else>
                        <div v-if="scope.row.exthfbj===null||scope.row.exthfbj==='0'">
                            <my-btn type="edit" @click="edit(scope.row.wtcode)" v-if="scope.row.scbj != '1'">回复</my-btn>
                        </div>
                        <div v-else>
                            <my-btn type="edit" @click="edit(scope.row.wtcode)" v-if="scope.row.scbj != '1'">追加回复</my-btn>
                            <my-btn type="detail" @click="detail(scope.row.wtcode)">详情</my-btn>
                        </div>
                    </div>
                    <div v-if="scope.row.scbj == '1'">
                        <el-tag type="danger">已撤销</el-tag>
                    </div>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('bidUrl')}/FaBiao/CqWt/getlist.json`"></my-pagination>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {   
        return{
            pgData:{
                procode:'',
                sortname : 'wtcode',                  
            },
            form:{},
            isreadshow:true,
            tableData:[],
            isTsNm:false,//唐山住建匿名项目提示
            reply:false,//匿名是否可回复
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        //刷新
        reload:function(){
            var that = this;
            this.isreadshow=false;
            this.$nextTick(function(){
                that.isreadshow=true;
            })
        },
        //详情
        detail:function(id){
            this.goto({
                path:'./detail',
                query:{
                    procode:this.pgData.procode,
                    id:id
                }
            });
        },
        //修改
        edit:function(id){
            this.goto({
                path:'./edit',
                query:{
                    procode:this.pgData.procode,
                    id:id
                }
            });
        }
    },
    created() {
        if(this.getQuery('procode')!=undefined){
            this.pgData.procode=this.getQuery('procode')
        }
    },
    mounted() {
        var that = this;
        this.$ajax({
            url:`${that.getGetters('bidUrl')}/FaBiao/CqWt/isShowNmMsg`,
            type:"get",
            data:{
                procode:that.getQuery('procode')
            },
            callback:function(data){
                that.reply = data;
            }
        })
    }
}
</script>

<style scoped lang="scss">

</style>